import { Route, Routes } from 'react-router-dom';
import Login from './Pages/Login/Login';
import CompanySignUp from './Pages/CompanySignUp/CompanySignUp';
import UserSignUp from './Pages/UserSignUp/UserSignUp';
import PaymentPage from './Pages/PaymentPage/PaymentPage';
import Dashboard from './Pages/Dashboard/Dashboard';
import MemberSignup from './Pages/MemberCreate/MemberSignup';
import Error404 from './Pages/Error404/Error404';
import { Navigate } from 'react-router-dom';

const Router = () => {
  return (
    <Routes>
      <Route exact path="/" element={<Dashboard selectedRoute={"AccessInterpreter"}/>} />
      <Route path="/Integrations" element={<Dashboard selectedRoute={"Integrations"}/>} />
      <Route path="/Invite" element={<Dashboard selectedRoute={"Invite"}/>} />
      <Route path="/Transactions" element={<Dashboard selectedRoute={"Transactions"}/>} />
      <Route path="/AccountInformation" element={<Dashboard selectedRoute={"AccountInformation"}/>} />
      <Route path="/AccountBilling" element={<Dashboard selectedRoute={"AccountBilling"}/>} />
      <Route path="/CompanySignUp" element={<CompanySignUp />} />
      <Route path="/UserSignUp" element={<UserSignUp />} />
      <Route path="/PaymentPage" element={<PaymentPage />} />
      <Route path="/Login" element={<Login />} />
      <Route path="/MemberSignup" element={<MemberSignup />} />
      <Route path="/404" element={<Error404 />} />
      <Route path="*" element={<Navigate to="/404"/>} />
    </Routes>
  );
}

export default Router;